import React from "react";
import Heatmap from "../../views/Heatmap";
import { actionCreators } from "./redux/heatmapSaga";
import { useSelector } from "react-redux";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import HeatmapLearnMore from "./smartComponents/HeatmapLearnMore";

const HeatmapModule = () => {
  const { fetchHeatmapData } = actionCreators;
  const { short_url, organization_id } = useSelector((state) => state.commonReducer.commonProps);

  return (
    <SectionToggle
      maxHeight="auto"
      autoHeight
      title="Customer Retention Heatmap"
      customClass="class-check-in-heatmap withSticky"
      learnMore={<HeatmapLearnMore />}
      content={
        <>
          <div id="react-heatmap-overlay"></div>
          <Heatmap
            stateName="retentionHeatmap"
            params={{ short_url, organization_id }}
            fetchHeatmapData={fetchHeatmapData}
            includeCrossRegionalVisits={{ value: true }}
          />
        </>
      }
    />
  );
};

export default React.memo(HeatmapModule);
